<template>
    <b-modal 
        id="modal-Import" 
        :title="title" 
        :no-close-on-backdrop="true"
        hide-footer 
        @hide="hiddenModal" 
        v-model="open"
        ref="modal-Import">
        <b-form>
            <b-form-group>
                <b-form-file :placeholder="placeholder" ref="file-input" :accept="accept" v-model="fileImport" >
                    <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                </b-form-file>
            </b-form-group>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="uploadFile" :loading="loading" noBorder></gofix-button>
            </b-button-group>
        </b-form>
    </b-modal>  
</template>
<script>
export default {
    name: 'modal-import',
    components: {
    },
    props: {
        value: {
            required: false,
            default: null
        },
        title: {
            type: String,
            required: false,
            default: 'Import File'
        },
        accept: {
            type: String,
            required: false,
            default: '.csv'
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Click Browse to upload file'
        }
    },
    data () {
        return {
            fileImport: null,
            open:    this.value,
            loading: false,
            timer:   null
        };
    },
    watch: {
        fileImport: function(val, old) {
            if (val) {
                let arrExtionsionAccept = ['csv']
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if(!arrExtionsionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$bvToast.toast('File format is incorrect. Please select a .csv file!', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'primary',
                        solid: true
                    })
                }
            }
        },
        value: function(val) {
            this.open = val;
        },
        open: function(val) {
            this.$emit("input", val);
        }
    },
    methods:{
        uploadFile() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if(this.loading) return;
                if (!this.fileImport) {
                    return this.$bvToast.toast("Please choose file to import", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                
                this.loading = true;
                new Promise((resolve, reject) => {
                    this.$emit('upload', async () => {
                        try {
                            return {
                                file: this.fileImport,
                                resolve,
                                reject,
                            }
                        } catch (e) {
                            reject(e)
                        }
                    })
                })
                .then(data => {
                    this.open    = false;
                    this.loading = false;
                    let variant  = 'success';
                    let result   = data.result;
                    let msg      = data.msg_success ? data.msg_success : 'Successfully imported';
                    if( result.data && result.data.count && result.data.count.failed ) {
                        variant  = 'danger';
                        msg      = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    return this.$bvToast.toast( msg, {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: variant,
                        solid: true
                    });
                })
                .catch(err => {
                    this.loading = false;
                    let msg = "Can't import data!";
                    if( err.response.data.error 
                        && err.response.data.error.message
                    ) {
                        msg = err.response.data.error.message;
                    }

                    return this.$bvToast.toast(msg, {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                });
            }, 200);
        },
        hiddenModal() {
            this.fileImport = null;
        }
    }
}
</script>
